export const flattenObject = (obj: object, keySeparator = '.'): Record<string, unknown> | undefined => {
	const flattenRecursive = (obj: object, parentProperty?: string, propertyMap: Record<string, unknown> = {}): Record<string, unknown> | undefined => {
		for (const [key, value] of Object.entries(obj)) {
			if (!key.includes('__typename')) {
				const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
				if (value && typeof value === 'object') {
					flattenRecursive(value, property, propertyMap);
				} else {
					propertyMap[property] = value || '';
				}
			}
		}
		return propertyMap;
	};
	return flattenRecursive(obj);
};

export const formatEndScore = (endScore: string): string => {
	const scores = endScore.split('-').filter((score) => score !== '');
	if (scores.length === 2) return `${scores[0]} -- ${scores[1]}`;
	return endScore;
};
